import React, { useEffect, useState } from 'react'
import TextField, { type TextFieldProps } from '@mui/material/TextField'

type EditableNumberFieldProps = Omit<TextFieldProps, 'type' | 'value' | 'onChange' | 'onBlur'> & {
  value: number
  onValueChange: (value: number) => void
}

const parseNumber = (raw: string) => {
  if (raw.trim() === '') return null
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : null
}

/** Keeps incomplete text locally, then publishes only valid numeric values. */
const EditableNumberField = ({ value, onValueChange, inputProps, ...props }: EditableNumberFieldProps) => {
  const [text, setText] = useState(String(value))

  useEffect(() => setText(String(value)), [value])

  return (
    <TextField
      {...props}
      type="text"
      value={text}
      inputProps={{ inputMode: 'decimal', ...inputProps }}
      onChange={event => {
        const nextText = event.target.value
        setText(nextText)
        const parsed = parseNumber(nextText)
        if (parsed !== null) onValueChange(parsed)
      }}
      onBlur={() => {
        const parsed = parseNumber(text)
        if (parsed === null) {
          setText(String(value))
          return
        }
        onValueChange(parsed)
        setText(String(parsed))
      }}
    />
  )
}

export default EditableNumberField
